const locale = {
	project_code: '工事コード :',
	branch: '現場支店 :',
};

export default locale;
